<template>
  <div>
    <DashboardTabs v-if="displayDashboardTabs" />
    <DashboardSideMenu v-if="displayDashboardSideMenu" />
    <router-view />

    <RecruitmentRecapModal />
  </div>
</template>

<script setup>
  import { computed } from "vue";
  import { useRoute } from "vue-router";
  import { Screen } from "quasar";
  import { RouterHelpers } from "@core/helpers";
  import { META_DASHBOARD_TABS, META_DASHBOARD_SIDEMENU } from "@etab/config";

  import RecruitmentRecapModal from "@etab/components/recruitments/detail/RecruitmentRecap.modal.vue";
  import DashboardSideMenu from "./DashboardSideMenu.component.vue";
  import DashboardTabs from "./DashboardTabs.component.vue";

  const route = useRoute();

  const displayDashboardTabs = computed(() => {
    return Screen.lt.sm && RouterHelpers.getRouteMeta(route, META_DASHBOARD_TABS);
  });

  const displayDashboardSideMenu = computed(() => {
    return Screen.gt.xs && RouterHelpers.getRouteMeta(route, META_DASHBOARD_SIDEMENU);
  });
</script>
